import { erpAxios } from '..';

const fetchCRKRegistry = async () => {
  const { data } = await erpAxios(`web-zahtjevi/registri/crkloanofficer`);
  return data;
};

export default fetchCRKRegistry;
